<mat-card class="slidecontent">
  <div class="pophead">
    <button mat-icon-button (click)="closedocumentDetail(closeDetail)" (click)="tabs.selectedIndex=0">
      <mat-icon>arrow_forward</mat-icon>
    </button>

    <div class="">
      <button (click)="closedocumentDetail(closeDetail)" (click)="tabs.selectedIndex=0" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>

  </div>


  <div class="detailtabs">
    <mat-tab-group #tabs animationDuration="0ms" (selectedTabChange)="onTabClick($event)">
      <mat-tab label="Detail">
        <div class="detail">

          <div class="input-inline">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Placeholder Name</mat-label>
              <input matInput placeholder="Enter Placeholder Name" [(ngModel)]="placeholderName"
                name="placeholderName" />
            </mat-form-field>

            <button mat-icon-button color="primary" matTooltip="Save" (click)="savePlaceHolderName()">
              <mat-icon>save</mat-icon>
            </button>


          </div>

          <!-- <div class="placeholder">
           <label>Placeholder Name</label>
            <div class="inputHolder">
              <input type="text" class="form-control"  placeholder="Add Placeholder Name" [(ngModel)]="placeholderName" >

             
            
              <button mat-icon-button color="primary" (click)="savePlaceHolderName()">
               <mat-icon>save</mat-icon>
              </button>
            </div>
  
          </div>   -->

        

          <!-- <div class="placeholder">

          
          <label>Project Name</label>
          <div class="inputHolder">
              <input type="text" placeholder="Project Name" value="{{projectName}}" (blur)="onChange($event.target.value)" >
          </div>


,
         <div class="input-inline">

          </div> -->
        
       
           <div class="input-inline">

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Project Name</mat-label>
              <input matInput placeholder="Enter Project Name" [(ngModel)]="projectName" name="projectName" />
            </mat-form-field>
             </div>


          <div class="docactions">
            <div class="act" *ngIf="formType!=3">
              <button [disabled]=!showAllDownloadButton matTooltip="download" (click)="downloadSelectedFile()" mat-icon-button color="primary">
                <mat-icon>cloud_download</mat-icon>
              </button>
              <span *ngIf="showAllDownloadButton">Download</span>
            </div>

            <div class="act" *ngIf="showLocalPanel">
              <button mat-icon-button color="primary" [routerLink]="'/esignature/first'">
                <mat-icon>format_shapes</mat-icon>
              </button>
              <span>Form Editor</span>
            </div>

            <div class="act" *ngIf="showLocalPanel">
              <button mat-icon-button color="primary" [routerLink]="'/request/signature'">
                <mat-icon>create</mat-icon>
              </button>
              <span>Sign</span>
            </div>

            <div class="act" *ngIf="showLocalPanel">
              <button mat-icon-button color="primary" (click)="shareFiles(shareFile)">
                <mat-icon>share</mat-icon>
              </button>
              <span>Email</span>
            </div>

            <div class="act" *ngIf="placeholderType!=2 && formType!=3">
              <input #Input hidden="true" type="file" onclick="this.value=null" (change)="UploadFile($event)" />
              <button mat-icon-button color="primary" matTooltip="Upload" (click)="Input.click()"
                matTooltipClass="tooltip">
                <mat-icon>cloud_upload</mat-icon>
              </button>
              <span>Upload</span>
            </div>

            <div class="act" *ngIf="formType!=3">
              <button [disabled]=!mergeButton matTooltip="Merge" (click)="mergeSelectedFile()" mat-icon-button color="primary">
                <mat-icon>merge</mat-icon>
              </button>
              <span *ngIf="mergeButton">Merge</span>
            </div>

            <!-- <div class="act" *ngIf="formType!=3">
              <button [disabled]=!showAllDownloadButton (click)="deleteSelectedFile()" mat-icon-button color="primary">
                <mat-icon>delete</mat-icon>
              </button>
              <span>Delete</span>
            </div> -->

          </div>


          <div class="history">
            <div class="title">
              <h3>Documents</h3>
              <span class="count">{{uploadHistory.length}}</span>
            </div>
            <div class="historylist" *ngFor="let history of uploadHistory">
              <div class="list">
                <mat-checkbox color="primary" [checked]="history.checked"
                  (change)="checkUploadHistoryElement($event, history)"></mat-checkbox>
                <div class="info" matTooltip="{{ getdocumentName(history.documentName) }}.{{history.fileType}}">
                  <h4 style="cursor: pointer;" (click)="openDocumentViewer(true,history,docViewer)">
                    {{ getdocumentName(history.documentName) }}.{{history.fileType}}
                    <!-- {{history.documentName}}.{{history.fileType}} -->
                  </h4>
                  <p *ngIf="history.createdByFirstName && history.createdByLastname && !history?.externalUploadedBy">
                    {{history.createdByFirstName}} {{history.createdByLastname}}
                    <!-- <span>{{history.createdOn+'Z' | date:'MM/dd/yyyy'}}
                      {{history.createdOn+'Z' | date:'h:mm a'}}
                    </span> -->
                  </p>
                  <p *ngIf="history.externalUploadedBy!=''">
                    {{ history.externalUploadedBy}}
                    <span *ngIf="history.createdOn!=null">{{history.createdOn+'Z' | date:'MM/dd/yyyy'}}
                      {{history.createdOn+'Z' | date:'h:mm a'}}
                    </span>
                  </p>
                  <p *ngIf="history.externalUploadedBy==''">
                    <span *ngIf="history.createdOn!=null">
                      {{history.createdOn+'Z' | date:'MM/dd/yyyy'}}
                      {{history.createdOn+'Z' | date:'h:mm a'}}
                    </span>
                  </p>
                </div>


                <button mat-icon-button matTooltip="View Document" (click)="openDocumentViewer(true,history,docViewer)">
                  <mat-icon>visibility</mat-icon>
                </button>

                <button
                  *ngIf="(history.fileType == 'pdf' || history.fileType == '.pdf') && history.fileManagerItemID > 0"
                  mat-icon-button matTooltipClass="tooltip" matTooltip="AI" (click)="showBindingFieldDetail(history)">
                  <i class="fa fa-reddit-alien f24" aria-hidden="true"></i>
                </button>

                <button mat-icon-button matTooltip="Download" (click)="DownloadSigleFile(history)">
                  <mat-icon>cloud_download</mat-icon>
                </button>

                <button mat-icon-button matTooltip="Edit" (click)="EditFile(myDialog,history)">
                  <mat-icon>edit</mat-icon>
                </button>

                <button *ngIf="history.pccDocumentID>0" matTooltip="cloud_done" mat-icon-button matTooltip="Uploaded to PointClickCare">
                  <mat-icon class="greenIcon" >sync</mat-icon>
                </button>

              </div>              
            
            </div>
            <div *ngIf="uploadHistory.length==0 && placeholderType==2">
              <p>These forms have not been filled out yet.</p>
            </div>
          </div>
          
        <div *ngIf="participantList?.length > 0" class="proInfo" >
          <div class="title">
            <h3>Participant</h3>
          </div>
         
            <div class="outerExpansion" *ngFor="let g of participantList; let i = index">
              <mat-accordion class="contacts">
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ g.groupName }} — Signers
                      <span class="group-count">
                        {{ getSignedCount(g) }}/{{ g.getProjectGroupRelationParticipantMappingModelList.length }} Signed
                      </span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <ng-container *ngFor="let p of g.getProjectGroupRelationParticipantMappingModelList">
                  <div  class="participant-card"
                      [ngClass]="[getStatusClass(p), !p.participantName?.trim() ? 'add-participant' : '']">
                    
                   
                    <div class="card-left">
                     
                      <div class="info">
                        <h4>

                          {{ p.participantName ? (p.participantName | titlecase) : 'Add Signer' }}

                           <span class="status-chip" [ngClass]="getStatusClass(p)">
                          {{ getStatusLabel(p) }}
                        </span>
                        
                        </h4>

                        <!-- <p>{{ p.contactEmail || p.participantEmail }}</p> -->

                        <div class="emails">

                          <div class="currentEmail" *ngIf="!p.enableEmailEdit">
                            <span *ngIf="p.participantEmail!='' && p.contactEmail!=''&& p.participantEmail!=undefined && p.contactEmail!=undefined && p.participantEmail!=null && p.contactEmail!=null">
                              {{p.contactEmail}}
                            </span>
                            <span *ngIf="p.participantEmail=='' || p.participantEmail==undefined ||  p.participantEmail==null ">
                              {{p.contactEmail}}
                            </span>
                            <span *ngIf="p.contactEmail=='' || p.contactEmail==undefined ||  p.contactEmail==null ">
                              {{p.participantEmail}}
                            </span>
                           
                           
                            <span *ngIf="!p.participantName?.trim()" class="assignRole"  >Click to assign someone to this role</span>
                            <button *ngIf="p.participantName?.trim()" class="addEmail" (click)="(editEmail(p,true))" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                          
                            </div>
                          <div class="updateEmail currentEmail" *ngIf="p.enableEmailEdit">                  
                            <input  type="text" placeholder="Add Email" ([ngModel])="updatedParticpantEmail" (blur)="EditParticipantEmail(p,$event)">
                            <button class="addEmail" (click)="(editEmail(p,false))" ><i class="fa fa-check" aria-hidden="true"></i></button>
                          </div>
                        
                        </div> 

                        
                        <div class="relationDate">
                          <button class="addEmail m-0" *ngIf="!p.participantName?.trim()" (click)="(editEmail(p,true))" ><i class="fa fa-user-plus" aria-hidden="true"></i></button>
                          <div class="relationname">{{p.relationName}} </div>

                        <small class="date" *ngIf="p.updatedOn">
                          {{ p.updatedOn+'Z' | date:'MMM d, y h:mm a' }}
                        </small>
                        </div>
                      </div>
                    </div>

                  
                    <div class="card-actions">
                      <a mat-icon-button matTooltip="Show Signing Page"
                        *ngIf="g.groupName!=='Send Final Copy'" [href]="p.signingToken" target="_blank">
                        <mat-icon>border_color</mat-icon>
                      </a>
                      <a mat-icon-button matTooltip="Send Reminder"
                              *ngIf="!p.hasCompleted && g.groupName!=='Send Final Copy' && g.groupName!=='View Only'"
                              (click)="ResendEmail(p)">
                        <mat-icon>notifications_active</mat-icon>
                    </a>
                      <a mat-icon-button matTooltip="Reopen Signing Link"
                              *ngIf="p.hasCompleted && g.groupName!=='Send Final Copy' && g.groupName!=='View Only'"
                              (click)="ReopenSignatureLink(p)">
                        <mat-icon>link</mat-icon>

                        
                  </a>
                      <a mat-icon-button matTooltip="Delete Participant"
                              (click)="deleteParticipant(p)">
                        <mat-icon>delete_outline</mat-icon>
                </a>
                    </div>
                  </div>
                  </ng-container>
                
                </mat-expansion-panel>
              </mat-accordion>
            </div>


        </div>


          <ng-container *ngIf="formType!=3">
            <div class="docactions" *ngIf="projectName==''">
              <p>Project Not Created Yet.</p>
            </div>
          </ng-container>


          <div *ngIf="placeholderType!=2 " form [formGroup]="RequiredForm" class="docactions">
            Required
            <mat-slide-toggle color="primary" (change)="onChangeDocumentRequired(RequiredForm.value)"
              formControlName="isRequired"></mat-slide-toggle>
          </div>



          <form class="docactions" *ngIf="placeholderType!=2 && formType!=3" [formGroup]="StatusCategoryForm">
            <mat-form-field>
              <mat-label>Approval</mat-label>
              <mat-select [disabled]='!isReviewer' [(ngModel)]="documentStatus" formControlName="status"
                (selectionChange)="onChangeDocumentStatus($event)">
                <mat-option *ngFor="let status of StatusCategory" [value]="status.id">
                  {{status.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>


          <div class="reviewrs" *ngIf="docReviewerList.length>0 && placeholderType!=2">
            <h3>Reviewer's List</h3>
            <div class="holdHistory">
              <div *ngIf=showAcceptedby class="hist">
                <span class="dot"></span>
                <div class="pic">
                  <span class="shortName">{{AcceptedbyFirstName | slice:0:1 }}{{AcceptedbyLastName | slice:0:1}}</span>
                </div>
                <span *ngIf="documentStatus ==2">Accepted By : {{AcceptedbyFirstName|titlecase}}
                  {{AcceptedbyLastName|titlecase}}.</span>
                <span *ngIf="documentStatus ==3">Rejected By : {{AcceptedbyFirstName|titlecase}}
                  {{AcceptedbyLastName|titlecase}}.</span>

                <span class="time">{{documentdetail.statusChangedOn| date:'MM/dd/yyyy' }} </span>
              </div>

              <ng-container *ngIf='docReviewerListTop2.length>0 && showTopTwoReviewer'>

                <div *ngFor='let a of docReviewerListTop2;let i=index' class="hist">
                  <span class="dot"></span>
                  <div class="pic">
                    <span class="shortName">{{a.sn}}</span>
                  </div>
                  <span *ngIf='a.roleID==0'> {{a.userName}} added as reviewer.</span>
                  <span *ngIf='a.roleID>0'> {{a.userName}} role added as reviewer.</span>
                </div>
              </ng-container>
              <ng-container *ngIf='docReviewerList.length>0 && docReviewerListTop2.length==0'>

                <div *ngFor='let a of docReviewerList;let i=index' class="hist">
                  <span class="dot"></span>
                  <div class="pic">
                    <span class="shortName">{{a.sn}}</span>
                  </div>
                  <span *ngIf='a.roleID==0'> {{a.userName}} added as reviewer.</span>
                  <span *ngIf='a.roleID>0'> {{a.userName}} role added as reviewer.</span>
                </div>
              </ng-container>
              <ng-container *ngIf='docReviewerList.length>0 && !showTopTwoReviewer'>

                <div *ngFor='let a of docReviewerList;let i=index' class="hist">
                  <span class="dot"></span>
                  <div class="pic">
                    <span class="shortName">{{a.sn}}</span>
                  </div>
                  <span *ngIf='a.roleID==0'> {{a.userName}} added as reviewer.</span>
                  <span *ngIf='a.roleID>0'> {{a.userName}} role added as reviewer.</span>
                </div>
              </ng-container>


            </div>
            <div class="showMore">
              <button mat-button color="primary" *ngIf='showTopTwoReviewer && docReviewerListTop2.length>0'
                (click)='ShowReviwers(false)'>Show More ({{docReviewerList.length+(showAcceptedby==true?1:0)}})</button>
              <button mat-button color="primary" *ngIf='!showTopTwoReviewer && docReviewerListTop2.length>0'
                (click)='ShowReviwers(true)'>Show Less</button>
            </div>
          </div>

            <!-- <div class="placeholder">
                       
            <label>Saved URL</label>

            <div class="inputHolder">
          <input type="text"  placeholder="" value="{{urlforPlaceholder}}" (blur)="onFormURLChange($event.target.value)"  />


            <div class="icon-actions">
              <button mat-icon-button color="primary" matTooltip="Copy" [cdkCopyToClipboard]="urlforPlaceholder">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button mat-icon-button color="primary" matTooltip="open_in_new_tab" (click)="openSavedURL()">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>
          
          </div>   -->
         
          <div class="input-inline">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Saved URL</mat-label>
              <input matInput [(ngModel)]="urlforPlaceholder" name="urlforPlaceholder" />
            </mat-form-field>


            <div class="icon-actions">
              <button mat-icon-button color="primary" matTooltip="Copy" [cdkCopyToClipboard]="urlforPlaceholder">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button mat-icon-button color="primary" matTooltip="open_in_new_tab" (click)="openSavedURL()">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>


          </div>
        
      </div>
      </mat-tab>

      <mat-tab label="Notes">

        <div class="touches_holder">
          <div class="detail">
            <div class="history">
              <div class="title">
                <div class="head">
                  <h3>Add Note</h3>
                </div>
                <button mat-icon-button color="primary" (click)="addTouch()" [ngClass]="{'active':  addNote }">
                  <mat-icon>add</mat-icon>
                </button>
              </div>

              <div class="historylist">
                <mat-card class="touches" *ngFor="let touch of AllCoreTouchesList">

                  <!-- Edit & Delete not ever implemented here just add below function to make that edit or delete-->
                  <!-- (editTouchEmmitter)="editTouch($event)"
                  (deleteTouchEmmitter)="deleteTouch($event)"      -->
                  <app-touches-list [touch]="touch"></app-touches-list>
                </mat-card>

              </div>
            </div>

          </div>
        </div>

      </mat-tab>

    </mat-tab-group>
  </div>
</mat-card>

<div class="documentOverlay" (click)="closedocumentDetail(closeDetail)"></div>




<ng-template #signature>
  <h2 mat-dialog-title>Add Signature</h2>
  <mat-dialog-content class="mat-typography">

    <div class="signaturePanel">
      <div class="left_pannel">
        <div class="esign">
          <mat-accordion>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Participants & Groups
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="panel">
                <div class="search">
                  <mat-form-field class="example-form-field">
                    <mat-label>Search and add participant </mat-label>
                    <input matInput type="text" />

                    <button mat-button matSuffix mat-icon-button aria-label="Clear">
                      <mat-icon>search</mat-icon>
                    </button>
                  </mat-form-field>
                </div>

                <div class="addparticipant">
                  <h3>Participants Order</h3>
                  <div class="addremove">
                    <button mat-icon-button color="primary">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <button mat-icon-button color="primary">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </div>

                <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="todo" [cdkDropListConnectedTo]="[doneList]"
                  class="group1" (cdkDropListDropped)="drop($event)">
                  <h2>Group 1</h2>
                  <div class="moveblock" *ngFor="let item of todo" cdkDrag>
                    <span>
                      <mat-checkbox color="{{item.color}}"></mat-checkbox>
                      {{ item.role }}
                    </span>

                    <span class="text-grey">
                      <button mat-icon-button (click)="assignUser(addAssigne)">
                        <mat-icon>person_add_alt_1</mat-icon>
                      </button>
                      <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                    </span>
                  </div>
                </div>
                <mat-menu #menu="matMenu" xPosition="before">
                  <button mat-menu-item>Assign</button>
                  <button mat-menu-item>Unassign</button>
                  <button mat-menu-item>Delete</button>
                </mat-menu>

                <div class="group1 final">
                  <h2>Send Final Copy</h2>

                  <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="done"
                    [cdkDropListConnectedTo]="[todoList]" class="getfinal" (cdkDropListDropped)="drop($event)">

                    <div class="moveblock" *ngFor="let item of done" cdkDrag>
                      <span>
                        <mat-checkbox color="{{item.color}}"></mat-checkbox>
                        {{item.role}}
                      </span>

                      <span class="text-grey">
                        <button mat-icon-button (click)="assignUser(addAssigne)">
                          <mat-icon>person_add_alt_1</mat-icon>
                        </button>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>


                <div class="group1 mt-10">
                  <h2>Non-Participant </h2>

                  <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="done"
                    [cdkDropListConnectedTo]="[todoList]" class="getfinal" (cdkDropListDropped)="drop($event)">

                  </div>
                </div>

              </div>
            </mat-expansion-panel>


          </mat-accordion>
        </div>
      </div>
      <div class="viewer">
        <embed src="../../../../../assets/Residential_Lease.pdf" type="application/pdf" width="100%" height="100%">
      </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic">Cancel</button>
    <button mat-button color="primary">Send</button>
  </mat-dialog-actions>

</ng-template>




<ng-template #addAssigne>

  <div class="head">
    <h2 matDialogTitle>Assign User</h2>
    <button mat-icon-button color="basic" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form class="assign">
      <app-contactlist></app-contactlist>

    </form>

  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary">Assign</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #myDialog>
  <form [formGroup]="formDialog">
    <h2 mat-dialog-title>
      Edit Document Name
      <button mat-icon-button (click)="closeEditDoc()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>Document Name</mat-label>
        <input matInput [required]="true" placeholder="add document name" formControlName="documentName"
          [(ngModel)]="fileNameEdit" />
        <mat-error *ngIf="formDialog.get('documentName').invalid &&
        (formDialog.get('documentName').dirty ||
        formDialog.get('documentName').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="closeEditDoc()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty"
        (click)="renameDocument()">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
    <app-loader></app-loader>
  </form>
</ng-template>

  <ng-template #docViewer> 
<app-document-viewer3c *ngIf="openDocumentViewers==true" [ngClass]="{ open: openDocumentViewers }"
    [documentData]="selectedDocument" [transactionID]="transactionID"
    (getCloseDocumentViewer)="getCloseDocumentViewer($event)">
  </app-document-viewer3c>
  </ng-template>